import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import * as constants from 'shared/constants';
import { AlertNotice, Accordion } from 'shared/components';
import { getPersonnelRoles } from 'shared/helpers';
import { isEmpty } from 'lodash';


const IrregularitiesList = (props) => {
  const { t } = useTranslation();
  const setName = (irr) => {
    let foundIrregularity;
    props.categories.forEach((categ) => {
      categ.irregularityTypes.forEach((type) => {
        if (type.id === irr.irregularityTypeId) {
          foundIrregularity = { ...type, ...irr };
        }
      });
    });
    return foundIrregularity;
  };


  const submitted = props.irregularities
    .filter(irr => !irr.reviewCompleteFlag)
    .map(setName);
  const approved = props.irregularities
    .filter(irr => irr.reviewCompleteFlag)
    .map(setName);

  const personnelRoles = getPersonnelRoles();

  return (
    <section className="irregularities-list pt-4 pb-4">
      <Accordion startPosition={props.startPosition} handleClick={position => props.setStartPosition(position)}>
        <div data-trigger={t('irregularities.submittedSectionTitle', { total: submitted.length })}>
          <section className="irreg-submitted">
            { submitted && submitted.length ?
              <div>
                <p className="font-size-12">{t('irregularities.moreDetailsMessage')}</p>
                {submitted.map(irr => irr && (
                  <div className="irregularity-item" key={irr.id} onClick={() => props.showInfo(irr.id)}>
                    <h6 className="font-size-12">{irr.name}</h6>
                    <p className="font-size-12">
                      <span>{moment(irr.submitDateTime).format('hh:mm A')} - {moment(irr.submitDateTime).format('MM/DD/YYYY')}</span>
                      { props.role === personnelRoles.COORDINATOR &&
                        irr.submitPersonnel && !isEmpty(irr.submitPersonnel) &&
                        (<span className="d-block">{irr.submitPersonnel.lastName}, {irr.submitPersonnel.firstName}</span>)
                      }
                    </p>
                  </div>
                ))}
              </div> :
              <AlertNotice message={t('irregularities.noSubmittedMessage')} />
            }
          </section>
        </div>
        <div data-trigger={t('irregularities.reviewedSectionTitle', { total: approved.length })}>
          <section className="irreg-approved">
            {approved && approved.length ?
              <div>
                <p className="font-size-12">{t('irregularities.moreDetailsMessage')}</p>
                {approved.map(irr => irr && (
                  <div className="irregularity-item" key={irr.id} onClick={() => props.showInfo(irr.id)}>
                    <h6>{irr.name}</h6>
                    <p className="font-size-12">
                      <span>{moment(irr.reviewDateTime).format('hh:mm A')}</span> -
                      <span>{moment(irr.reviewDateTime).format('MM/DD/YYYY')}</span>
                      { props.role === personnelRoles.COORDINATOR &&
                        irr.submitPersonnel && !isEmpty(irr.submitPersonnel) &&
                      (<span className="d-block">{irr.submitPersonnel.lastName}, {irr.submitPersonnel.firstName}</span>)}
                    </p>
                  </div>
                ))}
              </div> :
              <AlertNotice message={t('irregularities.noReviewedMessage')} />
            }
          </section>
        </div>
      </Accordion>
    </section>
  );
}

IrregularitiesList.propTypes = {
  irregularities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  showInfo: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
};

export default IrregularitiesList;
